class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.realButton = document.querySelector('.product-form__submit');
    this.priceSource = document.querySelector('[id^="price-"]');
    this.priceTarget = this.querySelector('[data-sticky-atc-price]');
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.buttonLabel = this.querySelector('[data-sticky-atc-button-label]');

    if (!this.realButton) {
      this.remove();
      return;
    }

    this.button.addEventListener('click', () => {
      this.realButton.click();
    });

    this.syncPrice();
    this.syncButtonState();

    if (this.priceSource) {
      this.priceObserver = new MutationObserver(() => this.syncPrice());
      this.priceObserver.observe(this.priceSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    this.buttonObserver = new MutationObserver(() => this.syncButtonState());
    this.buttonObserver.observe(this.realButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
    });

    this.setupVisibilityObserver();
  }

  syncPrice() {
    if (!this.priceSource || !this.priceTarget) return;
    const priceItem = this.priceSource.querySelector(
      '.price-item--sale, .price-item--regular, .price-item'
    );
    const text = priceItem ? priceItem.textContent : this.priceSource.textContent;
    this.priceTarget.textContent = text.trim();
  }

  syncButtonState() {
    if (!this.realButton || !this.button) return;
    this.button.disabled = this.realButton.disabled;
    const realLabel = this.realButton.querySelector('span');
    if (realLabel && this.buttonLabel) {
      this.buttonLabel.textContent = realLabel.textContent.trim();
    }
  }

  setupVisibilityObserver() {
    if (!this.realButton || !('IntersectionObserver' in window)) return;
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('sticky-atc--visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.realButton);
  }

  disconnectedCallback() {
    if (this.priceObserver) this.priceObserver.disconnect();
    if (this.buttonObserver) this.buttonObserver.disconnect();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
